export default {
	id: 'SIMPLE_PREMIUM_FALLBACK_3M_69_3M_15_99',
	providers: {
		paltaMap: {
			USD: 'simple_premium_3m_69_3m_15_99_usd',
			EUR: 'simple_premium_3m_69_3m_15_99_eur',
			GBP: 'simple_premium_3m_69_3m_15_99_gbp',
			AUD: 'simple_premium_3m_109_3m_35_19_aud',
			CAD: 'simple_premium_3m_109_3m_35_19_cad',
			DKK: 'simple_premium_3m_569_3m_183_2_dkk',
			SEK: 'simple_premium_3m_869_3m_279_2_sek',
			NOK: 'simple_premium_3m_869_3m_279_2_nok',
			BRL: 'simple_premium_3m_249_3m_55_2_brl',
			MXN: 'simple_premium_3m_1299_3m_263_2_mxn',
			TRY: 'simple_premium_3m_2299_3m_799_2_try',
			ARS: 'simple_premium_3m_90990_3m_21592_ars',
			COP: 'simple_premium_3m_279990_3m_64792_cop',
			CLP: 'simple_premium_3m_65990_3m_15992_clp',
		},
		primer: 'prd_gDWuklWBRdkv',
	},
}
